// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
    apiKey: "AIzaSyCrHeRJmAD3pmBgjddIidQ34_Xr0lM7Klo",
    authDomain: "fineats-5dd74.firebaseapp.com",
    projectId: "fineats-5dd74",
    storageBucket: "fineats-5dd74.appspot.com",
    messagingSenderId: "687257532910",
    appId: "1:687257532910:web:dcfd16be067b51acf836ff",
    measurementId: "G-4D28TK7VTE"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;